import { getIntl } from '../i18n/IntlProvider';

export const parseError = (e) => {
  const intl = getIntl();
  let translatedMessage = e.data?.message || null;

  // Regex: Match only if the string STARTS with a quoted field name (e.g., '"field.name" ...')
  const quotedFieldRegex = /^"([^"]+)"\s(.*)$/;

  // If the message starts with a quoted field name
  if (translatedMessage && quotedFieldRegex.test(translatedMessage)) {
    const translation = intl.formatMessage(
      { id: translatedMessage }, // Attempt to translate the full message
      {},
    );

    // If translation exists, use it; otherwise, use a default error message
    translatedMessage =
      translation !== translatedMessage
        ? translation
        : intl.formatMessage({ id: 'form.error', defaultMessage: 'Error in form!' });
  }

  return {
    error: {
      status: e.status,
      message: translatedMessage,
      canTryAgain: !translatedMessage,
      timestamp: e.timestamp,
    },
  };
};
